<ng-template dsTabulatableObjects></ng-template>
